import { useStore } from '@slope/store';
import { useMutableCallback } from '@slope/uikit';
import { Coords } from '@slope/utils';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

const raycaster = /*__@PURE__*/ new THREE.Raycaster();
raycaster.firstHitOnly = true;

export type LngLatProjectionResult = {
  position: THREE.Vector3Tuple;
  hit: THREE.Intersection<THREE.Object3D> | null;
};

/**
 * Converts geographic coordinates (longitude, latitude) to a 3D position in the scene.
 */
export const useLngLatProjection = () => {
  const lngLatToScene = useStore(({ lngLatToScene }) => lngLatToScene);
  const scene = useThree(({ scene }) => scene);

  return useMutableCallback((coordinates: Coords): LngLatProjectionResult => {
    const center = lngLatToScene(coordinates);

    raycaster.ray.origin.set(center[0], 100, center[2]);
    raycaster.ray.direction.set(0, -1, 0);

    const intersects = raycaster.intersectObject(scene, true);

    if (intersects.length > 0) {
      return {
        position: [center[0], intersects[0].point.y, center[2]],
        hit: intersects[0],
      };
    }
    return {
      position: [center[0], 0, center[2]],
      hit: null,
    };
  });
};
